import { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { clearUndoScope } from "actions/undoHistoryActions";
import { resolveScopeFromRoute } from "utils/undo/scopeKeys";

export function useUndoScopeCleanup() {
	const dispatch = useDispatch();
	const location = useLocation();
	const previousScopeRef = useRef(null);

	useEffect(() => {
		const nextScope = resolveScopeFromRoute(location);

		if (
			previousScopeRef.current &&
			previousScopeRef.current !== nextScope
		) {
			dispatch(clearUndoScope(previousScopeRef.current));
		}

		previousScopeRef.current = nextScope;
	}, [dispatch, location]);

	useEffect(() => {
		return () => {
			if (previousScopeRef.current) {
				dispatch(clearUndoScope(previousScopeRef.current));
			}
		};
	}, [dispatch]);
}
